/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_TryInputs */

const zh_landing_copilot_try = /** @type {(inputs: Landing_Copilot_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试试：`)
};

const en_landing_copilot_try = /** @type {(inputs: Landing_Copilot_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try:`)
};

const es_landing_copilot_try = /** @type {(inputs: Landing_Copilot_TryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba:`)
};

/**
* | output |
* | --- |
* | "Try:" |
*
* @param {Landing_Copilot_TryInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_copilot_try = /** @type {((inputs?: Landing_Copilot_TryInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_TryInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_try(inputs)
	if (locale === "en") return en_landing_copilot_try(inputs)
	return es_landing_copilot_try(inputs)
});